import LoggerProvider from "../providers/LoggerProvider";
/* eslint-disable no-console */
function loadGigyaSDK(apiKey) {
	return new Promise((resolve, reject) => {
		if (window.gigya && typeof window.gigya === "object") {
			resolve(window.gigya);
			return;
		}

		window.onGigyaServiceReady = function () {
			if (window.gigya) {
				console.log("Gigya SDK is ready");
				resolve(window.gigya);
			} else {
				reject(new Error("Gigya SDK not loaded"));
			}
		};

		const script = document.createElement("script");
		// script.src = `/static/data/gigya-mock.js?apikey=${apiKey}`; // test SDK
		script.src = `https://cdns.eu1.gigya.com/js/gigya.js?apikey=${apiKey}`;
		script.async = true;
		script.onerror = () => {
			LoggerProvider.logEvent({
				message: "Error loading Gigya SDK",
				eventName: "gigyaSdkHelper/loadGigyaSDK",
				eventCategory: "Gigya SDK",
				eventDomain: "LoyaltyUserTracking"
			});
			reject(new Error("Error loading Gigya SDK"));
		};
		document.head.appendChild(script);
	});
}

export default {
	loadGigyaSDK
};
